module.exports = __webpack_public_path__ + "static/media/IMG_0009.4f9b809e.jpg";